import React from 'react'

 const Order = () => {
  return (
    <div>order</div>
  )
}
 export default Order